import { Banner, CTA, HorizontalWordLoop } from '@/components'
import mailer from '../../assets/images/blog/samuel.webp'
import { Fade, JackInTheBox } from "react-awesome-reveal";

export const PrivacyPolicy = () => {

    return <>
        <JackInTheBox triggerOnce={true} delay={1000}>
            <Banner
                subtitle={".--. .-. .. ...- .- -.-. -.-- / .- -. -.. / .--. --- .-.. .. -.-. -.--"}
                title={'PRIVACY <span class="stroke white">POLICY </span>'}
            // image={mailer}
            // description="Create your software design blueprint with expert software design services."
            />
        </JackInTheBox>

        <div className="">
            <div className="container">
                <div className="row py-5 align-items-center justify-content-center justify-content-lg-start ">
                    <div className="col-lg-12 mt-lg-0 mt-3">
                        <h2 className='text-primary text-center'>Privacy Policy</h2>
                        <h3 className='text-primary'>ABOUT</h3>
                        <p className="text-white mt-3 ">
                            Serouj Khandjihanian built the Morse Code Academy app as a Free app. This SERVICE is provided by Serouj Khandjihanian at no cost and is intended for use as is. This page is used to inform visitors regarding my policies with the collection, use, and disclosure of Personal Information if anyone decided to use my Service. If you choose to use my Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that I collect is used for providing and improving the Service. I will not use or share your information with anyone except as described in this Privacy Policy. The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at Morse Code Academy unless otherwise defined in this Privacy Policy.
                        </p>

                        <h3 className='text-primary mt-3'>
                            LOG DATA
                        </h3>
                        <p className="text-white mt-3 ">
                            I want to inform you that whenever you use my Service, in a case of an error in the app I collect data and information (through third party products) on your phone called Log Data. This Log Data may include information such as your device Internet Protocol (“IP”) address, device name, operating system version, the configuration of the app when utilizing my Service, the time and date of your use of the Service, and other statistics.
                        </p>


                        <h3 className='text-primary mt-3'>
                            INFORMATION COLLECTION AND USE
                        </h3>
                        <p className="text-white mt-3 ">
                            The app does use third party services that may collect information used to identify you. Link to privacy policy of third party service providers used by the app such as Google Admob
                        </p>

                        <h3 className='text-primary mt-3'>
                            LINKS TO OTHER SITES
                        </h3>
                        <p className="text-white mt-3 ">
                            This Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by me. Therefore, I strongly advise you to review the Privacy Policy of these websites. I have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.
                        </p>

                        <h3 className='text-primary mt-3'>
                            CHILDREN'S PRIVACY
                        </h3>
                        <p className="text-white mt-3 ">
                            These Services do not address anyone under the age of 13. I do not knowingly collect personally identifiable information from children under 13 years of age. In the case I discover that a child under 13 has provided me with personal information, I immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact me so that I will be able to do necessary actions.
                        </p>

                        <h3 className='text-primary mt-3'>
                            CHANGES TO THIS PRIVACY POLICY
                        </h3>
                        <p className="text-white mt-3 ">
                            I may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. I will notify you of any changes by posting the new Privacy Policy on this page. This policy is effective as of 2021-04-14
                        </p>

                        <h3 className='text-primary mt-3'>
                            CONTACT US
                        </h3>
                        <p className="text-white mt-3 ">
                            If you have any questions or suggestions about my Privacy Policy, do not hesitate to contact me at<a href="mailto:seroujkh.dev@gmail.com">seroujkh.dev@gmail.com</a>
                        </p>
                        <p className="text-white mt-3 ">
                            This privacy policy page was created at<a href="https://privacypolicytemplate.net" target="_blank" rel="noopener noreferrer">privacypolicytemplate.net </a> and modfied/generated by <a href="https://app-privacy-policy-generator.nisrulz.com/" target="_blank" rel="noopener noreferrer">App Privacy Policy Generator</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <CTA />
    </>

}
